import styled from 'styled-components';

export const HelpFulSection = styled.section`
  display: flex;
  align-items: center;
  padding: 20px 0;
  border-top: 1px solid hsl(0deg, 0%, 0%, 10%);
  border-bottom: 1px solid hsl(0deg, 0%, 0%, 10%);
  margin-top: 10px;

  @media (max-width: 720px) {
    padding-left: 20px;
  }
`;

export const YesNoThumbs = styled.div`
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 14px;
  color: hsl(0deg, 0%, 0%, 80%);
  p {
    display: flex;
    align-items: center;
    margin-left: 20px;
    text-transform: uppercase;
    @media (min-width: 720px) {
      cursor: pointer;
    }

    img {
      width: 100%;
      max-width: 22px;
      height: 100%;
      margin-right: 4px;
    }
  }
`;

export const GetMyloApp = styled.button`
  font-family: 'Montserrat';
  outline: none;
  background: #fff;
  border: 1px solid hsl(0deg, 0%, 0%, 87%);
  border-radius: 20px;
  color: hsl(0deg, 0%, 0%, 87%);
  font-size: ${(props) => (props.nudge ? '10px' : '12px')};
  font-weight: 600;
  padding: ${(props) => (props.nudge ? '2px 8px' : '5px 12px')};
  margin-left: auto;
  cursor: pointer;

  @media (max-width: 720px) {
    cursor: default;
    display: ${(props) => (props.qna ? 'flex' : 'none')};
    align-items: center;
    width: ${(props) => (props.comment ? '92px' : '80.65px')};
    height: 24px;
  }

  span {
    display: flex;
    align-items: center;
  }

  svg {
    width: 18px;
    height: 18px;
  }

  &.shake_animate {
    animation: shakeButton 1s ease infinite;

    @keyframes shakeButton {
      30% {
        transform: scale(1.03);
      }
      40%,
      60% {
        transform: rotate(-7deg) scale(1.03);
      }
      50% {
        transform: rotate(7deg) scale(1.03);
      }
      70% {
        transform: rotate(0deg) scale(1.03);
      }
      100% {
        transform: scale(1);
      }
    }
  }

  &:hover {
    background: #ef4e5e;
    border: 1px solid #ef4e5e;
    color: #fff;

    @media (max-width: 720px) {
      background: #fff;
      color: hsl(0deg, 0%, 0%, 87%);
      border: 1px solid hsl(0deg, 0%, 0%, 87%);
      cursor: default;
    }
  }
`;

export const ThankYouFeedback = styled.div`
  display: flex;
  align-items: center;
  animation: showThanks 1.8s ease;

  span {
    font-size: clamp(14px, 2vw, 18px);
    font-weight: 500;
    display: inline-block;
    color: hsl(0deg, 0%, 0%, 87%);
  }
  @keyframes showThanks {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  img {
    width: 18px;
    height: 18px;
    margin-right: 10px;
  }
`;
